<template>
  <div id="app" v-cloak class="govgr-layout-wrapper govgr-layout-wrapper__full-height">
    <div class="govgr-header">
      <Navbar></Navbar>
    </div>
    <div v-cloak class="gov-width-container">
      <router-view></router-view>
    </div>
    <div class="govgr-footer">
      <Foot></Foot>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Navbar from '@/components/Navbar'
import Foot from '@/components/Foot'

export default {
  name: 'App',
  computed: {
    ...mapGetters({ currentUser: 'currentUser' })
  },
  created () {
    this.checkCurrentLogin()
  },
  updated () {
    this.checkCurrentLogin()
  },
  methods: {
    checkCurrentLogin () {
      if (!this.currentUser && this.$route.path !== '/') {
        this.$router.push('/login') // '/?redirect=' + this.$route.path
      }
    }
  },
  components: {
    Navbar,
    Foot
  }
}
</script>

<style lang="scss">
// [v-cloak] {

//   display: block;
//   padding: 50px 0;

//   @keyframes spinner {
//     to {
//       transform: rotate(360deg);
//     }
//   }

//   &:before {
//     content: '';
//     box-sizing: border-box;
//     position: absolute;
//     top: 50%;
//     left: 50%;
//     width: 20px;
//     height: 20px;
//     margin-top: -10px;
//     margin-left: -10px;
//     border-radius: 50%;
//     border: 2px solid #ccc;
//     border-top-color: #333;
//     animation: spinner .6s linear infinite;
//     text-indent: 100%;
//     white-space: nowrap;
//     overflow: hidden;
//   }

//   & > div {
//     display: none;
//   }
// }
// .el-form-item--small.el-form-item {
//   margin-bottom: 4px;
// }
// .el-input.is-disabled .el-input__inner {
//   background-color: #f5f7fa;
//   border-color: #e4e7ed;
//   color: #8595be;
//   cursor: not-allowed;
// }
// .el-radio__input.is-disabled+span.el-radio__label {
//   color: #8595be;
//   cursor: not-allowed;
// }
// .el-checkbox__input.is-disabled+span.el-checkbox__label {
//   color: #8595be;
//   cursor: not-allowed;
// }
// #app {
//   font-family: 'Avenir', Helvetica, Arial, sans-serif;
//   -webkit-font-smoothing: antialiased;
//   -moz-osx-font-smoothing: grayscale;
//   color: #2c3e50;
// }
</style>



// WEBPACK FOOTER //
// src/App.vue